import React from 'react';
import { motion } from 'framer-motion';

const rowVariants = {
  hidden: { opacity: 0, y: 4 },
  visible: (i) => ({
    opacity: 1, y: 0,
    transition: { delay: i * 0.04, duration: 0.18, ease: 'easeOut' },
  }),
};

const DataTable = ({ columns, rows, keyField = '_id', emptyText = 'No data found' }) => {
  return (
    <div className="zip-card overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-zip-surface border-b border-zip-border">
              {columns.map((col) => (
                <th key={col.key ?? col.label} className="zip-th">{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="zip-td text-center text-zip-muted py-12">
                  {emptyText}
                </td>
              </tr>
            ) : (
              rows.map((row, i) => (
                <motion.tr
                  key={row[keyField] ?? i}
                  custom={i}
                  variants={rowVariants}
                  initial="hidden"
                  animate="visible"
                  className="zip-tr border-b border-zip-border last:border-0"
                >
                  {columns.map((col) => (
                    <td key={col.key ?? col.label} className="zip-td">
                      {col.render ? col.render(row) : row[col.key]}
                    </td>
                  ))}
                </motion.tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;
